import ReactCSSTransitionGroup from 'react-transition-group/TransitionGroup';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CaseTracker from '@paypalcorp/disputes-case-tracker';
import _filter from 'lodash/filter';
import Article from '../components/Article';
import RelatedArticles from '../components/RelatedArticles';
import { FAQ_ARTICLE, FAQ_RELATED_ARTICLE, FAQ_ACTIVE_ARTICLE_CONTENT } from '../constants/PropTypesShapes';
import { trackPage } from '../../lib/analytics-helper';
import ColGrid from '../components/ColGrid';
import Page from '../../lib/page';
import { isDisputeTrackerEnabled } from '../../lib/TrackersHelper';
import i18n from '../../lib/reacti18n';

class ActiveArticle extends Component {
  static renderWithAnimation(component) {
    return (
      <ReactCSSTransitionGroup transitionName="expand" timeout={{ enter: 500 }}>
        {component}
      </ReactCSSTransitionGroup>
    );
  }

  isLoading() {
    return this.props.isLoadingArticle;
  }

  emptyChecker() {
    return this.props.relatedArticles.length === 0 && !this.props.article;
  }

  reletedArticleFilter() {
    const articleTitle = this.props.article && this.props.article.articleTitle;
    return _filter(this.props.relatedArticles, (relatedArticle) => articleTitle !== relatedArticle.articleTitle);
  }

  renderArticle() {
    const article = this.props.article;
    if (!article) {
      return null;
    }

    // Send impression FPTI for loaded Upfront FAQ without any rerender
    trackPage({
      id: 'contactUsPageUpfrontFAQ',
      link: `smarthelp-upfront-faq|loaded|${this.props.article.articleId}`,
      hpid: `${this.props.article.articleId}`,
      help_component_ids: `${this.props.article.ecmComponentIds}`,
      help_doc_id: `${this.props.article.ecmDocId}`,
    });
    return (
      <div className="article-content">
        <Article article={article} />
      </div>
    );
  }

  renderRelatedArticle() {
    const relatedArticles = this.reletedArticleFilter();
    let displayNumber = 2;
    let upfrontFAQId = '';
    if (relatedArticles.length === 0) {
      return null;
    }
    if (!this.props.article || this.props.article === {}) {
      displayNumber = 5;
    } else {
      upfrontFAQId = `|${this.props.article.articleId}`;
    }
    return (
      <div className="related-article-content">
        <RelatedArticles
          header={this.props.content.upfrontFaq.relatedArticle}
          relatedArticles={relatedArticles}
          displayNumber={displayNumber}
          upfront={upfrontFAQId}
        />
      </div>
    );
  }

  renderEnter() {
    if (this.isLoading()) {
      return null;
    }
    return (
      <div className="active-article-content">
        {this.renderArticle()}
        {this.renderRelatedArticle()}
      </div>
    );
  }

  renderDisputeCaseTracker() {
    // final intent
    const { article } = this.props;
    if (
      !article ||
      !article.articleId ||
      Page.isunSupportedBrowser() ||
      !isDisputeTrackerEnabled() ||
      !(
        Page.disputeArticle(article.articleId) ||
        Page.disputeBreadCrumb(article.articleMappedTo || article.breadCrumbPath)
      )
    ) {
      return null;
    }

    return (
      <CaseTracker
        flow="smarthelp:contact-us"
        fptiOptions={{
          page: 'main:help:smart::dispute-tracker:::',
          pgrp: 'main:help:smart::contact-us:::',
        }}
      />
    );
  }

  renderHeaderAndContent() {
    if (!this.props.display || this.emptyChecker()) {
      return null;
    }
    return (
      <div className="article-container">
        <ColGrid>
          {Page.isLoggedIn() ? this.renderDisputeCaseTracker() : null}
          <div className="vx_alert vx_alert-help active-article-alert">
            <div className="vx_alert-text">
              <p className="upfront-header">{this.props.content.upfrontFaq.header}</p>
              {ActiveArticle.renderWithAnimation(this.renderEnter())}
            </div>
          </div>
        </ColGrid>
      </div>
    );
  }

  render() {
    return this.renderHeaderAndContent();
  }
}

ActiveArticle.propTypes = {
  isLoadingArticle: PropTypes.bool,
  article: PropTypes.shape(FAQ_ARTICLE),
  relatedArticles: PropTypes.arrayOf(PropTypes.shape(FAQ_RELATED_ARTICLE)),
  display: PropTypes.bool,
  content: PropTypes.shape(FAQ_ACTIVE_ARTICLE_CONTENT),
};

ActiveArticle.defaultProps = {
  isLoadingArticle: true,
  article: undefined,
  relatedArticles: [],
  display: false,
  content: {
    'upfrontFaq.header': 'This information might help',
    'upfrontFaq.relatedArticle': 'Related topics',
  },
};

function mapStateToProps(state) {
  return {
    article: state.activeArticle.article,
    relatedArticles: state.activeArticle.relatedArticles,
    isLoadingArticle: state.activeArticle.isLoadingArticle,
    display: state.activeArticle.display,
    content: {
      upfrontFaq: {
        header: i18n.message('smarthelp/channelSelection.upfrontFaq.header'),
        relatedArticle: i18n.message('smarthelp/channelSelection.upfrontFaq.relatedArticle'),
      },
    },
  };
}

export default connect(mapStateToProps)(ActiveArticle);
